// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a04ae9d0","455":"e378ac6b","977":"a8b7b35f"}[chunkId] + ".chunk.js";
};